import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("hvsrNC3NKbcryqDs2DocYHZ9yPKEVzdSjQG6RVtK1s8");
//# sourceMappingURL=constants.js.map